import smoothScroll from 'smooth-scroll';
let options = {
  speed: 500,
  offset: window.innerWidth >= 1024 ? 0 : 50
};

let scroll = new smoothScroll('a[href*="#"]', options);


// var hash = location.hash;
//
// if ($(hash).length > 0) {
//   $(window).scrollTop(0);
//   setTimeout(function () {
//     scroll.animateScroll(document.querySelector(target), options);
//   }, 700);
// }

$(function() {
  // 変数にクラスを入れる
  var btn = $('.c-scrollPageTop');

  //スクロールしてページトップから100に達したらボタンを表示
  $(window).on('load scroll', function(){
    if($(this).scrollTop() > 600) {
      btn.addClass('active');
    }else{
      btn.removeClass('active');
    }
  });

  //フッターの手前でボタンを止める
  $(window).on('load scroll', function(){
    var height = $(document).height(), //ドキュメントの高さ
        position = window.innerHeight + $(window).scrollTop(), //ページトップから現在地までの高さ
        footer = $('footer').height(); //フッターの高さ
    if ( height - position  < footer ){
      btn.addClass('absolute');
    } else {
      btn.removeClass('absolute');
    }
  });

  //スクロールしてトップへ戻る
  btn.on('click',function () {
    $('body,html').animate({
      scrollTop: 0
    });
  });
});
